module.exports = __webpack_public_path__ + "static/media/IG.9853d510.png";